import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getEnv } from "../env-utils";

const env = getEnv().toLowerCase();
const DEFAULT_TITLE =
  env === "prod" ? "Prod - Data Marketplace" : `${getEnv()} - CatalogIQ`;

const DOMAIN_LEVELS = ["l5", "l4", "l3", "l2", "l1"];

const SECTION_TITLE_MAP = {
  report: "Report Discovery",
  CUSTOM_TAB: "Calculated fields discovery",
  glossary: "Glossary Discovery",
  businessDescription: "Business Description",
};

const ACTION_TAB_TITLE_MAP = {
  incidents: "Incident Management",
  "access-management": "Access Management",
};

const ACTION_SUBTAB_TITLE_MAP = {
  action: "My Action Items",
  access: "Access Requests",
};

const REPORT_TITLE_MAP = {
  "data-traffic-light": "Data Traffic Light",
  "code-quality": "Code Quality",
  "sfu-usage": "SFU Usage Metrics",
  "cost-monitoring": "Cost Monitoring",
  "platform-kpi": "Platform KPI",
  "product-usage": "Product Usage",
  "product-view": "Product View",
};

const STATIC_ROUTE_TITLE_MAP = {
  "/Dashboard": "Overview",
  "/dashboard": "Overview",
  "/userManagement": "User Management",
  "/feature-requests": "Leave Feedback",
  "/ai-assistant": "AI Assistant",
};

function getDeepestLevel(searchParams) {
  for (const level of DOMAIN_LEVELS) {
    const value = searchParams.get(level);
    if (value) return { level, value: decodeURIComponent(value) };
  }
  return null;
}

export default function usePageTitle() {
  const location = useLocation();

  useEffect(() => {
    const { pathname, search } = location;
    const searchParams = new URLSearchParams(search);

    if (pathname === "/dataDomain") {
      const deepestLevel = getDeepestLevel(searchParams);
      if (deepestLevel) {
        const title = deepestLevel.level === "l5"
          ? deepestLevel.value.replace(/\|/g, ".")
          : deepestLevel.value;
        document.title = title;
      }
    } else if (pathname === "/data-contract") {
      const section = searchParams.get("section");
      document.title = SECTION_TITLE_MAP[section] ?? "Asset Discovery";
    } else if (pathname === "/action") {
      const tab = searchParams.get("tab");
      const subtab = searchParams.get("subtab");
      if (subtab && ACTION_SUBTAB_TITLE_MAP[subtab]) {
        document.title = ACTION_SUBTAB_TITLE_MAP[subtab];
      } else if (tab && ACTION_TAB_TITLE_MAP[tab]) {
        document.title = ACTION_TAB_TITLE_MAP[tab];
      }
    } else if (pathname === "/data-monitoring") {
      const activeTab = searchParams.get("activeTab");
      const report = searchParams.get("report");
      if (activeTab === "overview") {
        document.title = "Data Quality Holistic";
      } else if (report && REPORT_TITLE_MAP[report]) {
        document.title = REPORT_TITLE_MAP[report];
      }
    } else if (pathname.startsWith("/product-report/")) {
      const product = searchParams.get("product");
      if (product) document.title = decodeURIComponent(product);
    } else if (STATIC_ROUTE_TITLE_MAP[pathname]) {
      document.title = STATIC_ROUTE_TITLE_MAP[pathname];
    } else {
      document.title = DEFAULT_TITLE;
    }
  }, [location]);
}
